import React from 'react';
//import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import NormalImg from '../common/Img';
import LogoImg from '../participants/bicamsinlogo.jpg';
import Button from '../common/Button';

const Img = styled(NormalImg)`
  width: 200px;
  margin: 20px;
  display: block;
`;
const ButtonA = styled(Button)`
  background: #324971;
  color: #fff;
`;
const ButtonB = styled(Button)`
  background: #7A062D;
  color: #fff;
`;

class ExamSubmitPage extends React.Component {

render() {
        //console.log();
        return (
            <div className="normalPage">
               <div className="container"> 

                   <div className="row">
                        <div className="col-xs-6">
                        <Img src={LogoImg} alt="Bicams Logo" />
                        </div>
                        <div className="col-xs-6">
                        
                        <Link to="/participants"><ButtonA className="btn btn-lg">Go back</ButtonA></Link>
                        <Link to="/logout"><ButtonB className="btn btn-lg">Logout</ButtonB></Link>
                        </div>
                    </div>  

                    <h2>Submit Exam Page</h2>   

                    <Link to="/logout"><ButtonA className="btn btn-lg">Logout</ButtonA></Link> 

               </div> 
            </div>
        );
    }

}

export default ExamSubmitPage;


// WEBPACK FOOTER //
// ./src/components/exam/ExamSubmitPage.js